var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58366 1.75H4.08366C3.43933 1.75 2.91699 2.27233 2.91699 2.91667V11.0833C2.91699 11.7277 3.43933 12.25 4.08366 12.25H9.91699C10.5613 12.25 11.0837 11.7277 11.0837 11.0833V5.25M7.58366 1.75L11.0837 5.25M7.58366 1.75V4.66667C7.58366 4.98883 7.84482 5.25 8.16699 5.25H11.0837M7.00033 7.58333V9.91667M8.16699 8.75H5.83366",
    stroke: "#272D55",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubSectionIcon);
export default __webpack_public_path__ + "static/media/SubSectionIcon.a396a01a49c61cb6aaf7aec0baef9ac7.svg";
export { ForwardRef as ReactComponent };